import { useAuthorizedInstallersDashboardContext } from '@authorizedInstaller/contexts';
import { AuthorizedInstallerFile } from '@authorizedInstaller/types/authorizedInstallers';
import EmblaCarousel from '@components/display/emblaCarousel/EmblaCarousel';
import { EmblaOptionsType } from 'embla-carousel';
import { useCallback, useState } from 'react';

const OPTIONS: EmblaOptionsType = { align: 'start', inViewThreshold: 1, dragFree: true };

const UploadedInstallations = () => {
    const { installerRequest } = useAuthorizedInstallersDashboardContext();
    const [currentSlide, setCurrentSlide] = useState(0);

    const onSlideChange = useCallback((newIndex: number) => {
        setCurrentSlide(newIndex);
    }, []);

    const renderSlide = useCallback(
        (file: AuthorizedInstallerFile) => (
            <div className="flex">
                <img src={file.file} className="my-auto" />
            </div>
        ),
        []
    );

    return installerRequest?.installation_files.length ? (
        <>
            <div className="h-[250px] my-5 flex items-center">
                <img
                    src={installerRequest?.installation_files[currentSlide]?.file}
                    className="max-w-[470px] mx-auto rounded-lg max-h-full"
                />
            </div>
            <div className="max-w-[580px] m-auto pt-5">
                <EmblaCarousel
                    slides={installerRequest?.installation_files}
                    options={OPTIONS}
                    current={currentSlide}
                    onSlideChange={onSlideChange}
                    spacing={10}
                    renderSlide={renderSlide}
                />
            </div>
        </>
    ) : (
        <div className={'w-full h-full flex items-center justify-center'}>
            <p className="bg-light-silver-60 py-5 px-8 rounded-xl font-roboto font-semibold text-black-80">
                No installations uploaded
            </p>
        </div>
    );
};

export { UploadedInstallations };
